import { ContentType, Method } from "axios-mapper";
import https from "../utils/https";

export const getAffiliateDownline = (id, query) => {
  return https().request(`/affiliate/${id}/downline`, Method.GET, query, ContentType.form);
};

export const regsterAffiliate = (affiliate) => {
  return https().request("/affiliate", Method.POST, affiliate, ContentType.form);
};

export const editAffiliateCommission = (id, affiliateCommission) => {
  return https().request(`/affiliate/${id}/commission?_method=PUT`, Method.POST, affiliateCommission, ContentType.form);
};

export const getAffiliateInfo = (id) => {
  return https().request(`/affiliate/${id}`, Method.GET);
};

export const loadBanks = (currencyId) => {
  return https('affiliate').request(`/session/withdraw/card?currencyId=${currencyId}`, Method.GET);
}

export const loadBankCards = () => {
  return https('affiliate').request(`/session/bankCard`, Method.GET);
}

export const addBankCard = (bci) => {
  return https('affiliate').request(`/session/bankCard`, Method.POST, bci, ContentType.form);
}

export const confirmWithdraw = (bci) => {
  return https('affiliate').request(`/session/withdraw/`, Method.POST, bci, ContentType.form);
}

export const withdrawEntrance = () => {
  return https('affiliate').request(`/session/withdraw/entrance`);
}

export function deleteBankCard(cardId) {
  return https('affiliate').request(`/session/bankCard/${cardId}?_method=delete`, Method.POST);
}

export const getAffiliateBalance = (id) => {
  return https().request(`/affiliate/${id}/balance`, Method.GET);
};

export const getAffiliateCommissionBalance = (id) => {
  return https().request(`/affiliate/${id}/commission-balance`, Method.GET);
};

// export const getAffiliateRealName = (id) => {
//   return https().request(`/affiliate/${id}/realName`, Method.GET);
// };

export const updateRealName = (updateInfo) => {
  return https('affiliate').request(`/session/account`, Method.POST, updateInfo, ContentType.form);
}

export const getAffiliateDomain = (id) => {
  return https().request(`/affiliate/${id}/domain`, Method.GET);
};

export const checkHasWithdrawPw = (id, siteId) => {
  return https().request(`/affiliate/${id}/hasWithdrawPw`, Method.GET, { siteId }, ContentType.form);
};

export const checkHasTelephone = (id, siteId) => {
  return https().request(`/affiliate/${id}/hasTelephone`, Method.GET, { siteId }, ContentType.form);
};

export const checkHasEmail = (id, siteId) => {
  return https().request(`/affiliate/${id}/hasEmail`, Method.GET, { siteId }, ContentType.form);
};

export const getSecurityQuestions = (id) => {
  return https().request(`/affiliate/${id}/securityQuestion`, Method.GET);
};

export const createSecurityQuestion = (id, securityQuestion) => {
  return https().request(`/affiliate/${id}/securityQuestion`, Method.POST, securityQuestion, ContentType.form);
};

export const checkAnswer = (id, answer) => {
  return https().request(`/affiliate/${id}/checkAnswer`, Method.GET, answer, ContentType.form);
};

export const checkWithdrawPassword = (id, siteId, withdrawPassword) => {
  return https().request(`/affiliate/${id}/checkWithdrawPassword`, Method.GET, { siteId, withdrawPassword }, ContentType.form);
};

export const loadMemberSummary = (id, query) => {
  return https().request(`/downline/${id}`, Method.GET, query, ContentType.form);
};

export const exportMemberSummary = (id, query) => {
  return https().request(`/downline/${id}/export`, Method.GET, query, ContentType.form);
};

export const loadMemberInfo = (id, memberId, recordTime, gameType) => {
  return https().request(`/downline/${id}/downlineInfo`, Method.GET, { memberId, recordTime, gameType }, ContentType.form);
};

export const assignTag = (affId, memberId, tags) => {
  return https().request(`/downline/${affId}/assignTag?_method=PUT`, Method.POST, { memberId, tagIds: tags.length !== 0 ? tags.join(",") : [] }, ContentType.form);
};

export const assignRemark = (affId, memberId, remark) => {
  return https().request(`/downline/${affId}/assignRemark/${memberId}?_method=PUT`, Method.POST, { remark }, ContentType.form);
};

export const getAuthenticator = (id, siteId) => {
  return https().request(`/affiliate/${id}/hasGoogleAuthenticator`, Method.GET, { siteId }, ContentType.form);
};

export const validPwd2GoogleKey = (id, siteId, password) => {
  return https().request(`/affiliate/${id}/validPwd2GoogleKey`, Method.GET, { siteId, password }, ContentType.form);
}

export const bindGoogleKey = (id, siteId, code) => {
  return https().request(`/affiliate/${id}/bindGoogleKey?_method=PUT`, Method.POST, { siteId, code }, ContentType.form);
}

export const sendBindTelephoneCode = (id, siteId, telephone, captchaCode, codeId) => {
  return https('affiliate').request(`/otp/sendSms`, Method.POST, { siteId, telephone, captchaCode, codeId }, ContentType.form);
}

export const bindTelephone = (id, siteId, telephone, code, codeId) => {
  return https('affiliate').request(`/session/verifyRegisteredPhoneOtp`, Method.POST, { siteId, telephone, code, codeId }, ContentType.form);
}

export const sendBindEmailCode = (id, siteId, email, captchaCode, codeId) => {
  return https('affiliate').request(`/otp/sendNewEmail`, Method.POST, { siteId, email, captchaCode, codeId }, ContentType.form);
}

export const bindEmail = (id, siteId, email, code, codeId) => {
  return https('affiliate').request(`/session/verifyAndUpdateEmail`, Method.POST, { siteId, email, code, codeId }, ContentType.form);
}

export const registerMember = (form) => {
  return https().request(`/downline/registerMember`, Method.POST, form, ContentType.form);
}

export const editMemberRatio = (memberId, ratio) => {
  return https().request(`/downline/${memberId}/editRatio?_method=PUT`, Method.POST, { memberShareRatio: ratio }, ContentType.form);
};

export const getDownlineShareRatio = (affId) => {
  return https().request(`/affiliate/${affId}/getDownlineShareRatio`, Method.GET);
};

export const getDownlineAffiliates = () => {
  return https().request('/downline/getAllDownlines', Method.GET);
};
